/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PlanRoadmapType from '@jira/spa-apps__advanced-roadmaps-plan-report/src/ExportedComponent.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Props } from '@jira/portfolio-3__portfolio/src/app-simple-plans/view/main/tabs/roadmap/types.tsx';

/**
 * Report page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanReport: LazyComponent<React.ComponentType<Props>> = lazyForPaint<
	typeof PlanRoadmapType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-report", jiraSpaEntry: "async-plan-report" */ '@jira/spa-apps__advanced-roadmaps-plan-report/src/ExportedComponent.tsx'
			),
		),
	{ ssr: false },
);

const PlanReport = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanReport} pageId="plan-report" shouldShowSpinner />
);

export default PlanReport;
